import { alpha } from "@mui/material";

const styles = (theme) => ({
  title: { fontWeight: "bold", fontSize: "20px" },
  mainPaper: {
    borderRadius: "16px",
    p: 2,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  paperContainer: {
    margin: "10px 0",
    p: 2,
    borderRadius: "16px",
  },
  icon: {
    fontSize: 22,
    color: theme.palette.white.main,
  },
  paperDatagrid: {
    width: "100%",
    overflowX: "auto",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    height: "calc(100vh - 360px)",
    minHeight: "400px",
  },
  datagridSx: {
    height: "100%",
    "& .MuiDataGrid-row:hover": {
      backgroundImage: `linear-gradient(
                    90deg,
                    ${alpha(theme.palette.buttonHoverGradient.dark, 0.5)} 0%,
                    ${alpha(theme.palette.buttonHoverGradient.light, 0.5)} 100%
                )`,
    },
    "& .MuiDataGrid-overlay": {
      height: "500px",
    },
  },
  searchField: {
    width: { xs: "100%", sm: "260px" },
    order: { xs: 1, sm: 1 },
  },
  paperBody: {
    p: 2,
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    backgroundColor: theme.palette.background.wallpaper,
    flex: 1,
  },
  subtitle: {
    fontWeight: "bold",
    fontSize: "10px",
    color: theme.palette.text.secondary,
    ml: 1,
  },
  containerHeader: {
    p: 1,
    pb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerButton: {
    textTransform: "none",
    borderRadius: "8px",
  },
  uploadBox: {
    p: 2,
    display: "flex",
    gap: 2,
    alignItems: "center",
    flexWrap: "wrap",
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: "8px",
    backgroundColor: theme.palette.background.paper,
  },
  textFieldDescription: {
    minWidth: 250,
  },
  avatarPreview: {
    height: 20,
    width: "auto",
    bgcolor: "transparent",
    cursor: "pointer",
    "& img": {
      objectFit: "contain",
      width: "100%",
      height: "100%",
    },
  },
  actionBox: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    gap: 1,
  },
  previewDialogBox: {
    p: 2,
    display: "flex",
    justifyContent: "center",
    bgcolor: "transparent",
  },
  previewDialogImg: {
    maxWidth: "100%",
    maxHeight: "80vh",
    objectFit: "contain",
  },
});

export default styles;
